export default __webpack_public_path__ + "static/media/DAIe.849478a7.png";